import { useEffect } from 'react';
import { AlertBox, AlertBoxDismissButton } from '@vp/swan';
import { __ } from '@99designs/i18n';

const TIMEOUT_MS = 4000;

export interface ToastProps {
    message: string;
    skin: 'success' | 'error';
    onDismiss: () => void;
}

export default function Toast({ message, skin, onDismiss }: ToastProps) {
    useEffect(() => {
        const timeoutId = setTimeout(() => onDismiss(), TIMEOUT_MS);
        return () => clearTimeout(timeoutId);
    }, [onDismiss]);

    return (
        <AlertBox mt={5} toast skin={skin}>
            {message}
            <AlertBoxDismissButton onClick={onDismiss} accessibleText={__('Close')} />
        </AlertBox>
    );
}
